// TODO: check if its calling uses await
export async function componentsCollectionByFilter(limit) {
  const { recents } = this.getRootState()
  const componentShowFilter = this.getUserSettings('componentShowFilter')
  const components = Object.values(this.getSchema('components'))
  if (componentShowFilter === 'all') {
    return limit ? components.filter((v, k) => k < limit) : components
  }
  if (componentShowFilter === 'recents') {
    const recentComponents = recents.map((v) => this.getSchema('components')[v])
    return limit
      ? recentComponents.filter((v, k) => k < limit)
      : recentComponents
  }
  if (componentShowFilter === 'builtins') {
    return {} // COMPONENTS
  }
  if (componentShowFilter === 'library') {
    return await this.getDefaultComponents()
  }

  return components.filter((v) => v[this.state.type])
}

export function componentsCollectionFilter(arr) {
  const { tags, filters, type } = this.state
  const { recents } = this.getRootState()
  const componentShowFilter = this.getUserSettings('componentShowFilter')
  const { category } = filters

  const categoryFilter = (v) => {
    if (v.draft) {
      return
    }

    if (category && tags.length) {
      return (
        v.category === category &&
        this.call('arrayContainsOtherArray', tags, v.tags || [])
      )
    }
    if (category) {
      return v.category === category
    }
    if (tags.length) {
      return this.call('arrayContainsOtherArray', tags, v.tags || [])
    }

    return true
  }

  if (componentShowFilter === 'all') {
    return category || tags ? arr.filter(categoryFilter) : arr
  }
  if (componentShowFilter === 'recents') {
    const recentComponents = recents
      .map((v) => this.getSchema('components')[v])
      .filter((v) => v)
    return category || tags
      ? recentComponents.filter(categoryFilter)
      : recentComponents
  }
  if (componentShowFilter === 'builtins') {
    return {} // COMPONENTS
  }
  if (componentShowFilter === 'library') {
    return {} // LIBRARY
  }

  return category || tags
    ? arr.filter((v) => v[type] && categoryFilter(v))
    : arr.filter((v) => v[type])
}
